import React, { useState } from 'react';

// PROMPT-161: Template Content Preview on Hover
const TemplateContentPreview = ({ content, children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const handleMouseEnter = (e) => {
    if (!content || content.length <= 50) return; // Don't show if content is short

    const rect = e.target.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    // Calculate position - show above if there's space, otherwise below
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;
    const tooltipHeight = 200; // Approximate height

    let top, left;
    if (spaceAbove > tooltipHeight + 10) {
      // Show above
      top = rect.top + scrollTop - tooltipHeight - 10;
    } else {
      // Show below
      top = rect.bottom + scrollTop + 10;
    }

    // Center horizontally with slight offset
    left = rect.left + scrollLeft + (rect.width / 2) - 150;

    // Keep within viewport
    if (left < 10) left = 10;
    if (left + 300 > window.innerWidth + scrollLeft - 10) {
      left = window.innerWidth + scrollLeft - 310;
    }

    setPosition({ top, left });
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  // Don't render wrapper if content is null/undefined
  if (!content) {
    return <div className="text-xs text-gray-500 truncate max-w-xs">No content</div>;
  }

  // If content is short, just return normal truncated view
  if (content.length <= 50) {
    return <div className="text-xs text-gray-500 truncate max-w-xs">{content}</div>;
  }

  return (
    <div className="relative">
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="text-xs text-gray-500 truncate max-w-xs cursor-help"
        title="Hover to see full content"
      >
        {content}
      </div>

      {isVisible && (
        <div
          className="fixed z-50 w-80 p-4 bg-gray-900 text-white rounded-lg shadow-xl border border-gray-700"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
            maxHeight: '200px',
            overflow: 'auto'
          }}
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={handleMouseLeave}
        >
          {/* Header */}
          <div className="flex items-center justify-between mb-2 pb-2 border-b border-gray-700">
            <span className="text-xs font-semibold text-gray-300">Template Content</span>
            <span className="text-xs text-gray-400">{content.length} characters</span>
          </div>

          {/* Content */}
          <div className="text-sm whitespace-pre-wrap break-words">
            {content}
          </div>

          {/* Footer */}
          <div className="mt-2 pt-2 border-t border-gray-700">
            <span className="text-xs text-gray-400">
              Variables: {(content.match(/{[^}]+}/g) || []).length} found
            </span>
          </div>

          {/* Arrow pointer */}
          <div 
            className="absolute w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-gray-900"
            style={{
              bottom: isVisible && position.top < 200 ? 'auto' : '-8px',
              top: isVisible && position.top >= 200 ? 'auto' : '-8px',
              left: '50%',
              transform: 'translateX(-50%)'
            }}
          />
        </div>
      )}
    </div>
  );
};

export default TemplateContentPreview;
